<template>
    <div>
        <navigation></navigation>
        <div class="pusher">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
    import Booking from '../admin/Booking'
    import Navigation from '../admin/Navigation'

    export default {
        components: {
            Booking, Navigation
        }
    }
</script>



// WEBPACK FOOTER //
// Admin.vue?0bdf7d7e